import type { CSSProperties } from 'react';
import { useTheme } from 'next-themes';
import { Toaster as Sonner, type ToasterProps } from 'sonner';

type ToastCSSVariables = CSSProperties &
  Record<
    | '--normal-bg'
    | '--normal-text'
    | '--normal-border'
    | '--success-bg'
    | '--success-text'
    | '--success-border'
    | '--error-bg'
    | '--error-text'
    | '--error-border'
    | '--warning-bg'
    | '--warning-text'
    | '--warning-border',
    string
  >;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = 'system' } = useTheme();
  const toastStyles: ToastCSSVariables = {
    '--normal-bg': 'var(--popover)',
    '--normal-text': 'var(--popover-foreground)',
    '--normal-border': 'var(--border)',
    '--success-bg': 'var(--color-swd-gruen-light)',
    '--success-text': 'var(--color-swd-tuerkis-darker)',
    '--success-border': 'var(--color-swd-gruen-dark)',
    '--error-bg': 'var(--color-alert-error-bg)',
    '--error-text': 'var(--color-alert-error)',
    '--error-border': 'var(--color-alert-error)',
    '--warning-bg': 'var(--color-alert-warning)',
    '--warning-text': 'var(--color-neutral-schwarz)',
    '--warning-border': 'var(--color-alert-warning)',
  };

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className='toaster group'
      richColors
      style={toastStyles}
      {...props}
    />
  );
};

export { Toaster };
